<template>
  <div id="vacancyreport" class="vacancyreport" v-loading.body="loading">
    <el-row style="height:100%">
      <el-col :span="24" style="height:100%;">
        <div style="padding:5px;">
          <el-radio-group v-model="candidateStatus" @change="changeStatus" size="mini">
            <el-radio-button label="0" >Документы поданы</el-radio-button>
            <el-radio-button label="1" >К конкурсу допущен</el-radio-button>
            <el-radio-button label="2" >Пакет документов отклонен</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="period" @change="changePeriod" style="float:right" size="mini">
            <el-radio-button label="0" >За все время</el-radio-button>
            <el-radio-button label="1" >За последний месяц</el-radio-button>
            <el-radio-button label="2" >За последнюю неделю</el-radio-button>
          </el-radio-group>
        </div>
        <div style="padding:5px;">
          <el-select v-model="comittee" placeholder="Выберите орган исполнительной власти" style="width:100%;" @change="changeComittee" clearable filterable>
            <el-option
              v-for="item in comittees"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div style="height:100%;padding:5px;">
          <el-table
            ref="vacancyData"
            :data="vacancies"
            border
            highlight-current-row
            show-summary
            :summary-method="getSummaries"
            v-bind:height="resultsTableHeight"
            style="width: 100%; height: 100%;" header-cell-class-name="default-header-color">
            <el-table-column
              property="fullName"
              label="Кандидат"
              sortable
              class="grid-text-overflow"
              >
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.fullName" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.fullName }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              property="statusString"
              label="Статус заявки"
              sortable
              class="grid-text-overflow"
              >
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.statusString" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.statusString }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="Дата подачи заявки"
              property="dateOfApplication"
              sortable
              class="grid-text-overflow"
              width="200">
              <template slot-scope="scope">
                <el-icon name="time"></el-icon>
                <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.dateOfApplication)" placement="top">
                  <span class="grid-text-overflow" style="margin-left:10px;">{{ formatDate(scope.row.dateOfApplication) }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              property="comitteeLabel"
              label="Комитет"
              sortable
              class="grid-text-overflow"
              >
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.comitteeLabel" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.comitteeLabel }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              property="position"
              label="Должность"
              sortable
              class="grid-text-overflow"
              >
              <template slot-scope="scope">
                 <el-tooltip class="item" effect="dark" :content="scope.row.position" placement="top">
                   <span class="grid-text-overflow">{{ scope.row.position }}</span>
                 </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'

  export default {
    name: 'vacancyreport',
    data() {
      return {
        loading: false,
        comittees: [],
        vacancies: [],
        resultsHeight: null,
        candidateStatus: 0,
        period: 0,
        comittee: null
      }
    },
    computed: {
      resultsTableHeight: function() {
        if(!this.resultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            return height - 127;
        }
        return this.resultsHeight - 97;
      }
    },
    methods: {
      fetch(comittee, status, period) {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          let comitteeId = this.comittee ? this.comittee : '';
          let url = `${prefix}vacancy/report?timePeriod=${this.period}&status=${this.candidateStatus}&comitteeId=${comitteeId}`;
          self.$http.get(url, options)
            .then(response => {
              self.loading = false;
              self.vacancies = response.data;
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });

          self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      fetchCombos() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///COMBOS
          self.$http.get(`${prefix}vacancy/comittees`, options)
            .then(response => {
              self.comittees = response.data;
              self.loading = false;
            })
            .catch(data => {
              self.$gf.checkError(data);
              self.loading = false;
            });
          self.loading = false;
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        sums[0] = 'Всего заявок:';
        sums[1] = this.vacancies ? this.vacancies.length : 0;

        return sums;
      },
      changeStatus() {
        this.fetch(this.period, this.candidateStatus, this.comittee);
      },
      changePeriod() {
        this.fetch(this.period, this.candidateStatus, this.comittee);
      },
      changeComittee() {
        this.fetch(this.period, this.candidateStatus, this.comittee);
      },
      getLabelById(array, id) {
        return grid.getLabelById(array, id);
      },
      getLabelByCode(array, code) {
        return grid.getLabelByCode(array, code);
      },
      formatDate(d) {
        return grid.formatDate(d);
      },
      formatDateWithHoursAndMinutes(d) {
        return grid.formatDateWithHoursAndMinutes(d);
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height)
          this.resultsHeight = height - 30;
        else
          this.resultsHeight = null;
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.fetchCombos();
      this.fetch(this.period, this.candidateStatus, this.comittee);
    }
  }
</script>

<style scoped>
  .vacancyreport {
    height: calc(100% - 20px);
    --border: 1px solid #d1dbe5;
    padding: 10px;
    --overflow-y: scroll;
  }
  .middle-aligned {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .grid-text-overflow {
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
<style>
  .el-radio-button__inner {
    min-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/vacancyreport.vue